
import React from 'react'
import { Dropdown } from 'semantic-ui-react'

interface PageLimitI {
  perPage: number;
  changePage: (n: number) => void;

}

   let options: any[] = [
        {
            key: '15',
            text: '15',
            value: 15,
        }, {
            key: '25',
            text: '25',
            value: 25,
        },
        {
            key: '50',
            text: '50',
            value: 50,
        },
        {
          key: '100',
          text: '100',
          value: 100,
      },


    ]
       
   
const PageLimit: React.FC<PageLimitI> = ({ perPage, changePage }) => {

  const checkType= (event: React.SyntheticEvent<HTMLElement, Event>, data: any) => {
    
    changePage(data.value)
    
    
  }
  
  
    return (
        
         <Dropdown
                    fluid
                    selection
                    options={options}
                    onChange={checkType}
                    closeOnEscape
                    value={perPage}
                    style={{ background: "transparent" }} />
    
    )
}

export default PageLimit
